import cn from "classnames";

import { ObjectBanner } from "./components/ObjectBanner";
import { ObjectDetails } from "./components/ObjectDetails";
import { CalculatedData } from "./components/CalculatedData";

import { Post } from "types/post.type";

import styles from "./InvestmentBasicData.module.scss";

const InvestmentBasicData = ({
  className,
  activePosition,
  post,
  calculation,
  conclusionsPro,
  proCalculationCharts,
  onPositionChange,
}: {
  className?: string;
  withBanner?: boolean;
  activePosition: 10 | 20 | 30;
  tags: { label: string; value: string }[];
  post?: Post;
  conclusionsPro: any;
  calculation: any;
  proCalculationCharts: any;
  onPositionChange: (position: 10 | 20 | 30) => void;
}) => (
  <div className={cn(styles.root, className)}>
    <ObjectBanner post={post} />
    <ObjectDetails
      activePosition={activePosition}
      conclusionsPro={conclusionsPro}
    />
    <CalculatedData
      activePosition={activePosition}
      proCalculationCharts={proCalculationCharts}
      calculation={calculation}
      conclusionsPro={conclusionsPro}
      onPositionChange={onPositionChange}
    />
  </div>
);

export default InvestmentBasicData;
